import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BaseModalService } from '@app/core/services/base-modal.service';

enum modalSizeClassEnum {
  Small = 'w-1/4',
  Medium = 'w-1/2',
  Large = 'w-3/4',
  FullScreen = 'w-full h-full',
}

@Component({
    selector: 'app-base-modal',
    templateUrl: './base-modal.component.html',
    standalone: false
})

export class BaseModalComponent {

  id!: string;
  size = 'medium';
  title = 'Modal Title';

  modalSizeClass!: string;
  modalOpen!: boolean;

  @Output() confirm$ = new EventEmitter<boolean>();

  constructor(
    private modalService: BaseModalService,
    public formBuilder: FormBuilder
  ) {}

  close() {
    this.modalService.close(this.id);
  }

  confirm() {
    this.confirm$.emit(true);
  }
}
